import React from 'react'

// import styles
import './NameWrapper.css'

// hoc for one line clamping
const NameWrapper = ({children, className, onClick}) => {

  return (
    <span className={`mues_one_line_clamp ${className}`} onClick={onClick}>{children}</span>
  )
}

export default NameWrapper